import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    class: _normalizeClass(`cds-dialog ${_ctx.shortTitleComputed.toLowerCase().replace(/ /g, '-')}-cds-dialog`),
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDialog) = $event))
  }, {
    activator: _withCtx((props) => [
      _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps(props)))
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "cds-dialog-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            class: "cds-dialog-close-icon cds-touch-pad",
            icon: "square-xmark",
            size: "xl",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDialog = false)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.showDialog = false), ["enter"])),
            color: _ctx.color,
            tabindex: "0"
          }, null, 8, ["color"]),
          _createVNode(_component_v_card_title, { tabindex: "0" }, {
            default: _withCtx(() => [
              _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _cache[3] || (_cache[3] = _createTextVNode(" Add content to the default slot ", -1))
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class", "modelValue"]))
}